<script setup>
import { NuxtLink } from '#components'
import { getTarget } from '~/utils/externalLink'

const props = defineProps({
  slide: {
    type: Object,
    required: true,
  },
})
</script>

<template>
  <component
    :is="props.slide?.to ? NuxtLink : 'div'"
    :to="props.slide?.to"
    :target="getTarget(props.slide?.to)"
    class="slide d-flex"
  >
    <div class="slide__image">
      <NuxtImg
        v-if="props.slide?.image?.src"
        sizes="sm:340px md:440px lg:800px"
        densities="1x 2x"
        :src="props.slide?.image?.src"
        :alt="props.slide?.image?.alt"
        loading="lazy"
        format="webp"
        :placeholder="[300, 200, 60, 2]"
      />
    </div>
    <div
      v-if="props.slide?.title"
      class="d-flex flex-column slide__content"
    >
      <h3 class="scale-1 scale-1--bold slide__text">
        {{ props.slide?.title }}
      </h3>
    </div>
  </component>
</template>

<style lang="scss" scoped>
@import '~/assets/scss/variables.scss';

.slide {
  height: 100%;
  width: 100%;
  position: relative;
  overflow: hidden;
  &__zoom {
    &:hover,
    &:focus,
    &:active {
      img {
        transition: transform 0.5s ease;
        transform: scale(1.05);
      }
    }
  }
  &__image {
    position: relative;
    display: flex;
    width: 100%;
    height: auto;

    img {
      height: 100%;
      width: 100%;
      object-fit: cover;
    }

    &::after {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      height: 100%;
      width: 100%;
      background: linear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.5));
    }
  }

  &__content {
    position: absolute;
    text-align: left;
    bottom: 0;
    left: 0;
    padding: 14px 25px;
    height: 100%;
    width: 100%;
  }

  &__text {
    margin-top: auto;
    text-transform: uppercase;
  }
}
</style>
